import type { Currency } from 'dinero.js'

import i18n from 'modules/core/lib/i18n'

export function formatAmount(amountInCents: number, currency: Currency): string {
  return i18n.formatNumber(amountInCents / 100, 'currency', currency)
}
